export enum Interest {
	CoupleImprovement = 1,
	CoupleImprovementDescription = <any>'Mejorar como pareja',

	SelfImprovement = 2,
	SelfImprovementDescription = <any>'Mejorar como persona',

	ParentHoohImprovement = 3,
	ParentHoohImprovementDescription = <any>'Mejorar como padres',

	ProblemSolving = 4,
	ProblemSolvingDescription = <any>'Resolver problemas de pareja',

	MarriageSaving = 5,
	MarriageSavingDescription = <any>'Salvar el matrimonio',

	GroupKnowing = 6,
	GroupKnowingDescription = <any>'Conocer el movimiento',

	Other = 7,
	OtherDescription = <any>'Otro interés'
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/enums/interest.enum.ts